import React, { type FC } from 'react';

import styles from './AccordionPanel.module.scss';
import CollapsibleContainer from './CollapsibleContainer/CollapsibleContainer';
import Header from './Header/Header';

type AccordionPanelProps = {
    title: string;
    onSectionClick: () => void;
    icon: React.ReactNode;
    displayDateTime: string;
    isExpanded: boolean;
    children: React.ReactNode;
};

export const AccordionPanel: FC<AccordionPanelProps> = ({
    title,
    isExpanded,
    onSectionClick,
    children,
    icon,
    displayDateTime,
}) => {
    return (
        <div className={styles.container}>
            <Header
                title={title}
                text={displayDateTime}
                icon={icon}
                onClick={onSectionClick}
            />
            <CollapsibleContainer isExpanded={isExpanded}>
                {children}
            </CollapsibleContainer>
        </div>
    );
};
